import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auto container" }
const _hoisted_2 = { class: "auto__body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "auto__title title" }, "Автоматизируйте бизнес-процессы", -1)
const _hoisted_4 = { class: "auto__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "auto__desc" }, " Подключайте привычные приложения, которые вы используете в работе. ", -1)
const _hoisted_6 = ["src"]

import SmallForm from './SmallForm.vue'
import { IMAGE_BASE_URL } from '@/config'

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoSect',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(SmallForm, { class: "form-light" })
      ]),
      _createElementVNode("img", {
        src: _unref(IMAGE_BASE_URL) + 'auto-lines.png',
        class: "auto__dec",
        alt: ""
      }, null, 8, _hoisted_6)
    ])
  ]))
}
}

})